import styled from 'styled-components';

export const TooltipContent = styled.div`
  min-width: 200px;
  padding: 8px 0;
`;

export const TooltipTitle = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  margin-bottom: 8px;
  padding: 0 12px 8px;
  border-bottom: 1px solid rgb(255 255 255 / 20%);
`;

export const TooltipEventItem = styled.div`
  padding: 4px 12px;

  &:not(:last-child) {
    margin-bottom: 4px;
  }
`;

export const EventName = styled.div`
  font-size: 13px;
  color: #fff;
  margin-bottom: 2px;
`;

export const EventId = styled.div`
  font-size: 12px;
  color: rgb(255 255 255 / 65%);
`;
